export default __webpack_public_path__ + "cf2eab7d08e083a58fc565ddd6de562a.svg";